<div class="dispatch-finder-container">
  <!-- Filters Bar -->
  <div class="filters-bar" [class.collapsed]="filtersCollapsed">
    <div class="filter-controls">
      <button
        class="btn btn-sm btn-outline-secondary filter-toggle-btn"
        (click)="toggleFilters($event)"
        [title]="filtersCollapsed ? 'Expand filters' : 'Collapse filters'"
      >
        <i
          class="fa"
          [class.fa-chevron-down]="!filtersCollapsed"
          [class.fa-chevron-right]="filtersCollapsed"
        ></i>
      </button>
      <button
        *ngIf="!filtersCollapsed"
        class="btn btn-sm btn-outline-secondary"
        (click)="clearFilters()"
        title="Clear all filters"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>

    <ng-container *ngIf="!filtersCollapsed">
      <!-- Location Filters -->
      <div class="filter-group">
        <div class="filter-row">
          <div class="filter-item filter-item-location">
            <label>Location</label>
            <div class="location-picker-wrapper">
              <app-location-picker
                [tableId]="'locationTable'"
                [buttonId]="'locationButton'"
                [isSelected]="!!filters.location"
                [locationName]="filters.location?.name || ''"
                [locId]="filters.location?.locId || ''"
                [placeholder]="'Select Location'"
                (locationSelected)="onLocationSelected($event)"
              ></app-location-picker>
              <button
                *ngIf="filters.location"
                type="button"
                class="btn btn-sm btn-outline-secondary clear-location-btn"
                (click)="clearLocation()"
                title="Clear location"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-item">
            <label>Miles from Location</label>
            <input
              type="number"
              class="form-control form-control-sm"
              [(ngModel)]="filters.milesFromLocation"
              (ngModelChange)="onDriverFilterChange()"
              min="1"
              max="5000"
            />
          </div>
        </div>
      </div>

      <!-- Driver Filters -->
      <div class="filter-group">
        <div class="filter-row">
          <div class="filter-item filter-item-driver-search">
            <label>Search Driver</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="filters.driverSearch"
              (ngModelChange)="onDriverFilterChange()"
              placeholder="Name or number..."
            />
          </div>
          <div class="filter-item">
            <label>Status</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.driverStatus"
              (ngModelChange)="onDriverFilterChange()"
            >
              <option *ngFor="let status of driverStatuses" [ngValue]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
          <div class="filter-item">
            <label>Type</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.driverType"
              (ngModelChange)="onDriverFilterChange()"
            >
              <option [ngValue]="null">All</option>
              <option *ngFor="let type of driverTypes" [ngValue]="type.value">
                {{ type.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-item">
            <label>Product Qual.</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.productQualification"
              (ngModelChange)="onDriverFilterChange()"
            >
              <option [ngValue]="null">All</option>
              <option *ngFor="let qual of productQualifications" [ngValue]="qual.value">
                {{ qual.label }}
              </option>
            </select>
          </div>
          <div class="filter-item">
            <label>Date (For time off)</label>
            <input
              type="date"
              class="form-control form-control-sm"
              [(ngModel)]="filters.date"
              (ngModelChange)="applyFilters()"
            />
          </div>
        </div>
      </div>

      <!-- Trailer Filters -->
      <div class="filter-group">
        <div class="filter-row">
          <div class="filter-item filter-item-driver-search">
            <label>Search Trailer</label>
            <div class="search-with-checkbox">
              <input
                type="text"
                class="form-control form-control-sm search-input"
                [(ngModel)]="filters.trailerSearch"
                (ngModelChange)="onTrailerFilterChange()"
                placeholder="Trailer number..."
              />
              <label class="checkbox-inline">
                <input
                  type="checkbox"
                  [(ngModel)]="filters.includeTrailersOutOfService"
                  (ngModelChange)="onTrailerFilterChange()"
                />
                Include OOS
              </label>
            </div>
          </div>
          <div class="filter-item">
            <label>Trailer Status</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.trailerStatus"
              (ngModelChange)="onTrailerFilterChange()"
            >
              <option *ngFor="let status of trailerStatuses" [ngValue]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-item">
            <label>Trailer Terminal</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.trailerTerminal"
              (ngModelChange)="onTrailerFilterChange()"
            >
              <option [ngValue]="null">All</option>
              <option *ngFor="let terminal of terminals" [ngValue]="terminal.value">
                {{ terminal.label }}
              </option>
            </select>
          </div>
          <div class="filter-item">
            <label>Trailer Product</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.trailerProduct"
              (ngModelChange)="onTrailerFilterChange()"
            >
              <option [ngValue]="null">All</option>
              <option *ngFor="let product of productQualifications" [ngValue]="product.value">
                {{ product.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Tractor Filters -->
      <div class="filter-group">
        <div class="filter-row">
          <div class="filter-item filter-item-driver-search">
            <label>Search Tractor</label>
            <div class="search-with-checkbox">
              <input
                type="text"
                class="form-control form-control-sm search-input"
                [(ngModel)]="filters.tractorSearch"
                (ngModelChange)="onTractorFilterChange()"
                placeholder="Tractor number..."
              />
              <label class="checkbox-inline">
                <input
                  type="checkbox"
                  [(ngModel)]="filters.includeTractorsOutOfService"
                  (ngModelChange)="onTractorFilterChange()"
                />
                Include OOS
              </label>
            </div>
          </div>
          <div class="filter-item">
            <label>Tractor Status</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.tractorStatus"
              (ngModelChange)="onTractorFilterChange()"
            >
              <option *ngFor="let status of tractorStatuses" [ngValue]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-item">
            <label>Tractor Terminal</label>
            <select
              class="form-control form-control-sm"
              [(ngModel)]="filters.tractorTerminal"
              (ngModelChange)="onTractorFilterChange()"
            >
              <option [ngValue]="null">All</option>
              <option *ngFor="let terminal of terminals" [ngValue]="terminal.value">
                {{ terminal.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Cards List -->
    <div class="cards-panel">
      <div class="cards-header">
        <span>{{ cards.length }} Results</span>
        <div class="selection-actions">
          <button class="btn btn-sm btn-link" (click)="deselectAll()">Clear Selection</button>
        </div>
      </div>

      <div class="cards-list" #cardsList>
        <!-- Driver Section -->
        <div class="category-section" *ngIf="getCategoryCards('driver').length > 0">
          <div class="category-header" (click)="toggleCategory('drivers')">
            <i
              class="fa"
              [class.fa-chevron-down]="categoryVisibility.drivers"
              [class.fa-chevron-right]="!categoryVisibility.drivers"
            ></i>
            <i class="fa fa-user category-icon"></i>
            <span class="category-title">Drivers</span>
            <span class="selected-indicator" *ngIf="getSelectedInCategory('driver') as selected">
              <i class="fa fa-check-circle"></i> {{ selected.name }} ({{ selected.driverNo }})
            </span>
            <span class="category-count">({{ getCategoryCards("driver").length }})</span>
          </div>
          <div class="category-content" *ngIf="categoryVisibility.drivers">
            <ng-container *ngFor="let card of getCategoryCards('driver')">
              <!-- Driver Card -->
              <div
                class="dispatch-card driver-card"
                [class.selected]="card.selected"
                [attr.data-card-id]="card.id"
                (click)="toggleCardSelection(card)"
              >
                <div class="card-type-header">
                  <span class="card-type-label"><i class="fa fa-user"></i> DRIVER</span>
                </div>
                <div class="card-checkbox">
                  <input
                    type="checkbox"
                    [checked]="card.selected"
                    (click)="$event.stopPropagation()"
                  />
                </div>
                <div class="card-content driver-card-content">
                  <div class="driver-layout">
                    <div class="driver-avatar-col">
                      <div class="driver-avatar">
                        <img [src]="getDriverPictureUrl(card)" alt="Driver photo" />
                      </div>
                    </div>
                    <div class="driver-info-col">
                      <div class="driver-name">
                        <span class="driver-name-text">{{ card.name }}</span>
                        <a
                          [href]="'/drivers/' + card.id"
                          target="_blank"
                          title="Open driver profile"
                          (click)="$event.stopPropagation()"
                          class="profile-link"
                          ><i class="fa fa-external-link"></i
                        ></a>
                      </div>
                      <div class="driver-meta-row">
                        <div class="driver-number">{{ card.driverNo }}</div>
                        <span
                          class="badge"
                          [ngClass]="{
                            'badge-company': card.driverType === 'COMPANY DRIVER',
                            'badge-lessor': card.driverType === 'LEASE OPERATOR',
                            'badge-owner': card.driverType === 'OWNER OPERATOR',
                          }"
                          >{{ getDriverTypeLabel(card.driverType) }}</span
                        >
                      </div>
                      <div class="driver-team-row" *ngIf="card.schedulingTeamName">
                        <i class="fa fa-users"></i>
                        <span class="driver-team-name">{{ card.schedulingTeamName }}</span>
                      </div>
                      <div
                        class="driver-team-row driver-board-row"
                        *ngIf="card.schedulingTeamBoardName"
                      >
                        <i class="fa fa-th-list"></i>
                        <span class="driver-board-name">{{ card.schedulingTeamBoardName }}</span>
                      </div>
                      <div
                        class="driver-qualifications"
                        *ngIf="
                          card.productQualifications.length > 0 ||
                          card.prequalifiedProductQualifications.length > 0
                        "
                      >
                        <div class="qualification-tags">
                          <span
                            class="qualification-tag"
                            *ngFor="let qual of card.productQualifications"
                            [title]="qual"
                          >
                            {{ qual }}
                          </span>
                          <span
                            class="qualification-tag prequalified"
                            *ngFor="let qual of card.prequalifiedProductQualifications"
                            [title]="qual + ' (Pre-Qualified)'"
                          >
                            {{ qual }} <span class="pre-q-label">Pre-Q</span>
                          </span>
                        </div>
                      </div>
                      <div class="driver-details">
                        <span
                          [title]="
                            'Location' + (card.locationAge ? ' (' + card.locationAge + ')' : '')
                          "
                        >
                          <i class="fa fa-map-marker"></i> {{ card.location || "Unknown" }}
                        </span>
                        <span title="Miles driven in last 7 days"
                          ><i class="fa fa-road"></i> {{ card.milesLast7Days | number }} mi</span
                        >
                        <span title="Home city"
                          ><i class="fa fa-home"></i> {{ card.homeCity }},
                          {{ card.homeState }}</span
                        >
                        <span
                          *ngIf="card.hoursOfService !== null"
                          title="Hours of service remaining"
                          ><i class="fa fa-clock-o"></i>
                          {{ card.hoursOfService | number: "1.1-1" }} HOS</span
                        >
                        <span *ngIf="card.tractorNumber" title="Assigned tractor">
                          <i class="fa fa-truck"></i>
                          <a
                            *ngIf="card.tractorId"
                            [href]="'/tractors/' + card.tractorId"
                            target="_blank"
                            (click)="$event.stopPropagation()"
                            class="equipment-link"
                            >{{ card.tractorNumber }}</a
                          >
                          <span *ngIf="!card.tractorId">{{ card.tractorNumber }}</span>
                        </span>
                        <span *ngIf="card.trailerNumber" title="Assigned trailer">
                          <i class="fa fa-list"></i>
                          <a
                            *ngIf="card.trailerId"
                            [href]="'/trailers/' + card.trailerId"
                            target="_blank"
                            (click)="$event.stopPropagation()"
                            class="equipment-link"
                            >{{ card.trailerNumber }}</a
                          >
                          <span *ngIf="!card.trailerId">{{ card.trailerNumber }}</span>
                        </span>
                        <span
                          *ngIf="card.attachedTrailerNumbers.length > 0"
                          [title]="
                            'Trailers on tractor (HOS): ' + card.attachedTrailerNumbers.join(', ')
                          "
                          ><i class="fa fa-list"></i>
                          {{ card.attachedTrailerNumbers.join(", ") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Trailer Section -->
        <div class="category-section" *ngIf="getCategoryCards('trailer').length > 0">
          <div class="category-header" (click)="toggleCategory('trailers')">
            <i
              class="fa"
              [class.fa-chevron-down]="categoryVisibility.trailers"
              [class.fa-chevron-right]="!categoryVisibility.trailers"
            ></i>
            <i class="fa fa-subway category-icon"></i>
            <span class="category-title">Trailers</span>
            <span class="selected-indicator" *ngIf="getSelectedInCategory('trailer') as selected">
              <i class="fa fa-check-circle"></i> {{ selected.trailerNumber }}
            </span>
            <span class="category-count">({{ getCategoryCards("trailer").length }})</span>
          </div>
          <div class="category-content" *ngIf="categoryVisibility.trailers">
            <ng-container *ngFor="let card of getCategoryCards('trailer')">
              <!-- Trailer Card -->
              <div
                class="dispatch-card trailer-card"
                [class.selected]="card.selected"
                [attr.data-card-id]="card.id"
                (click)="toggleCardSelection(card)"
              >
                <div class="card-type-header">
                  <span class="card-type-label"><i class="fa fa-trailer"></i> TRAILER</span>
                </div>
                <div class="card-checkbox">
                  <input
                    type="checkbox"
                    [checked]="card.selected"
                    (click)="$event.stopPropagation()"
                  />
                </div>
                <div class="card-content driver-card-content">
                  <div class="driver-top-row">
                    <div class="driver-name-col">
                      <div class="trailer-number">
                        {{ card.trailerNumber }}
                        <a
                          [href]="'/trailers/' + card.id"
                          target="_blank"
                          title="Open trailer profile"
                          (click)="$event.stopPropagation()"
                          class="profile-link"
                          ><i class="fa fa-external-link"></i
                        ></a>
                      </div>
                      <div *ngIf="card.equipmentCode" class="driver-number">
                        {{ card.equipmentCode }}
                      </div>
                      <div class="driver-details" style="margin-top: 4px">
                        <span [title]="card.locationAge || 'Current location'">
                          <i class="fa fa-map-marker"></i> {{ card.currentLocation || "Unknown" }}
                        </span>
                        <span title="Terminal">
                          <i class="fa fa-building"></i> {{ card.terminal || "N/A" }}
                        </span>
                        <span
                          *ngIf="card.attachedTractorNumber"
                          title="Paired tractor (location sourced from tractor)"
                        >
                          <i class="fa fa-truck"></i> {{ card.attachedTractorNumber }}
                        </span>
                      </div>
                    </div>
                    <div class="card-side-info">
                      <div class="card-badges">
                        <span
                          class="badge"
                          [ngClass]="card.inService ? 'badge-in-service' : 'badge-out-of-service'"
                        >
                          {{ card.inService ? "In Service" : "Out of Service" }}
                        </span>
                        <span
                          class="badge"
                          [ngClass]="card.assigned ? 'badge-assigned' : 'badge-unassigned'"
                        >
                          {{ card.assigned ? "Assigned" : "Unassigned" }}
                        </span>
                      </div>
                      <div
                        class="next-service"
                        *ngIf="card.daysUntilNextService !== null"
                        title="Days until next service"
                      >
                        <span class="next-service-label">Next Service:</span>
                        <span
                          class="next-service-days"
                          [ngClass]="{
                            'text-danger': card.daysUntilNextService <= 7,
                            'text-warning':
                              card.daysUntilNextService > 7 && card.daysUntilNextService <= 30,
                            'text-success': card.daysUntilNextService > 30,
                          }"
                          >{{ card.daysUntilNextService }} days</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Tractor Section -->
        <div class="category-section" *ngIf="getCategoryCards('tractor').length > 0">
          <div class="category-header" (click)="toggleCategory('tractors')">
            <i
              class="fa"
              [class.fa-chevron-down]="categoryVisibility.tractors"
              [class.fa-chevron-right]="!categoryVisibility.tractors"
            ></i>
            <i class="fa fa-truck category-icon"></i>
            <span class="category-title">Tractors</span>
            <span class="selected-indicator" *ngIf="getSelectedInCategory('tractor') as selected">
              <i class="fa fa-check-circle"></i> {{ selected.tractorNumber }}
            </span>
            <span class="category-count">({{ getCategoryCards("tractor").length }})</span>
          </div>
          <div class="category-content" *ngIf="categoryVisibility.tractors">
            <ng-container *ngFor="let card of getCategoryCards('tractor')">
              <!-- Tractor Card -->
              <div
                class="dispatch-card tractor-card"
                [class.selected]="card.selected"
                [attr.data-card-id]="card.id"
                (click)="toggleCardSelection(card)"
              >
                <div class="card-type-header">
                  <span class="card-type-label"><i class="fa fa-truck"></i> TRACTOR</span>
                </div>
                <div class="card-checkbox">
                  <input
                    type="checkbox"
                    [checked]="card.selected"
                    (click)="$event.stopPropagation()"
                  />
                </div>
                <div class="card-content driver-card-content">
                  <div class="driver-top-row">
                    <div class="driver-name-col">
                      <div class="tractor-number">
                        {{ card.tractorNumber }}
                        <a
                          [href]="'/tractors/' + card.id"
                          target="_blank"
                          title="Open tractor profile"
                          (click)="$event.stopPropagation()"
                          class="profile-link"
                          ><i class="fa fa-external-link"></i
                        ></a>
                      </div>
                      <div class="driver-details" style="margin-top: 4px">
                        <span [title]="card.locationAge || 'Current location'">
                          <i class="fa fa-map-marker"></i> {{ card.currentLocation || "Unknown" }}
                        </span>
                        <span title="Terminal">
                          <i class="fa fa-building"></i> {{ card.terminal || "N/A" }}
                        </span>
                        <span
                          *ngIf="card.attachedTrailerNumbers?.length"
                          [title]="'Attached trailers: ' + card.attachedTrailerNumbers.join(', ')"
                        >
                          <i class="fa fa-list"></i> {{ card.attachedTrailerNumbers.join(", ") }}
                        </span>
                      </div>
                    </div>
                    <div class="card-side-info">
                      <div class="card-badges">
                        <span
                          class="badge"
                          [ngClass]="card.inService ? 'badge-in-service' : 'badge-out-of-service'"
                        >
                          {{ card.inService ? "In Service" : "Out of Service" }}
                        </span>
                        <span
                          class="badge"
                          [ngClass]="card.assigned ? 'badge-assigned' : 'badge-unassigned'"
                        >
                          {{ card.assigned ? "Assigned" : "Unassigned" }}
                        </span>
                      </div>
                      <div
                        class="next-service"
                        *ngIf="card.daysUntilNextService !== null"
                        title="Days until next service"
                      >
                        <span class="next-service-label">Next Service:</span>
                        <span
                          class="next-service-days"
                          [ngClass]="{
                            'text-danger': card.daysUntilNextService <= 7,
                            'text-warning':
                              card.daysUntilNextService > 7 && card.daysUntilNextService <= 30,
                            'text-success': card.daysUntilNextService > 30,
                          }"
                          >{{ card.daysUntilNextService }} days</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Map Panel -->
    <div class="map-panel" (mousemove)="onMapMouseMove($event)">
      <div class="map-header">
        <div class="map-legend">
          <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
            <input
              type="checkbox"
              [(ngModel)]="showTypes.drivers"
              (ngModelChange)="onShowTypeChange()"
            />
            <i class="fa fa-circle text-primary"></i> Drivers
          </label>
          <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
            <input
              type="checkbox"
              [(ngModel)]="showTypes.trailers"
              (ngModelChange)="onShowTypeChange()"
            />
            <i class="fa fa-circle text-success"></i> Trailers
          </label>
          <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
            <input
              type="checkbox"
              [(ngModel)]="showTypes.tractors"
              (ngModelChange)="onShowTypeChange()"
            />
            <i class="fa fa-circle text-danger"></i> Tractors
          </label>
          <span class="legend-item"><i class="fa fa-circle text-purple"></i> Selected</span>
          <span class="legend-item" *ngIf="locationMarker"
            ><i class="fa fa-circle text-warning"></i> Filtered Location</span
          >
        </div>
        <!-- <button
          class="btn btn-primary"
          (click)="assignSelected()"
          [disabled]="getSelectedCards().length === 0"
        >
          <i class="fa fa-link"></i> Assign Schedule ({{ getSelectedCards().length }})
        </button> -->
      </div>
      <div class="map-container">
        <google-map
          width="100%"
          height="100%"
          [center]="mapCenter"
          [zoom]="mapZoom"
          [options]="mapOptions"
          (zoomChanged)="onMapZoomChanged()"
        >
          <map-marker *ngIf="locationMarker" [options]="locationMarker"></map-marker>
          <map-circle *ngIf="locationCircle" [options]="locationCircle"></map-circle>
          <map-marker
            *ngFor="let m of allMapMarkers"
            [options]="m.options"
            (mapClick)="onMarkerClick(m)"
            (mapMouseover)="onMarkerMouseOver(m, $event)"
            (mapMouseout)="onMarkerMouseOut()"
          ></map-marker>
        </google-map>
      </div>

      <!-- Map Tooltip -->
      <div
        class="map-tooltip"
        *ngIf="hoveredMarker"
        [style.left.px]="tooltipX"
        [style.top.px]="tooltipY"
      >
        <!-- Cluster -->
        <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'cluster'">
          <div class="mtt-header mtt-cluster">
            <i class="fa fa-map-marker"></i>
            {{ hoveredMarker.tooltipData.clusterCount }} Units
          </div>
          <div class="mtt-body">
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterDrivers?.length">
              <span class="mtt-label"><i class="fa fa-user"></i> Drivers</span>
              <span class="mtt-value">{{
                hoveredMarker.tooltipData.clusterDrivers!.join(", ")
              }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterTractors?.length">
              <span class="mtt-label"><i class="fa fa-truck"></i> Tractors</span>
              <span class="mtt-value">{{
                hoveredMarker.tooltipData.clusterTractors!.join(", ")
              }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterTrailers?.length">
              <span class="mtt-label"><i class="fa fa-list"></i> Trailers</span>
              <span class="mtt-value">{{
                hoveredMarker.tooltipData.clusterTrailers!.join(", ")
              }}</span>
            </div>
          </div>
        </ng-container>

        <!-- Driver -->
        <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'driver'">
          <div class="mtt-header mtt-driver">
            <i class="fa fa-user"></i>
            {{ hoveredMarker.tooltipData.name }}
            <span class="mtt-driverno">#{{ hoveredMarker.tooltipData.driverNo }}</span>
          </div>
          <div class="mtt-body">
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.schedulingTeamName">
              <span class="mtt-label"><i class="fa fa-users"></i> Team</span>
              <span class="mtt-value">
                {{ hoveredMarker.tooltipData.schedulingTeamName }}
                <span *ngIf="hoveredMarker.tooltipData.schedulingTeamBoardName" class="mtt-board"
                  >&mdash; {{ hoveredMarker.tooltipData.schedulingTeamBoardName }}</span
                >
              </span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
              <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
              <span class="mtt-value">
                {{ hoveredMarker.tooltipData.location }}
                <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
                  >({{ hoveredMarker.tooltipData.locationAge }})</span
                >
              </span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.tractorNumber">
              <span class="mtt-label"><i class="fa fa-truck"></i> Tractor</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.tractorNumber }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.trailerNumber">
              <span class="mtt-label"><i class="fa fa-list"></i> Trailer</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.trailerNumber }}</span>
            </div>
            <div class="mtt-stats">
              <span
                *ngIf="
                  hoveredMarker.tooltipData.hoursOfService !== null &&
                  hoveredMarker.tooltipData.hoursOfService !== undefined
                "
              >
                <i class="fa fa-clock-o"></i>
                {{ hoveredMarker.tooltipData.hoursOfService | number: "1.1-1" }} HOS
              </span>
              <span>
                <i class="fa fa-road"></i>
                {{ hoveredMarker.tooltipData.milesLast7Days | number }} mi
              </span>
            </div>
            <div class="mtt-quals" *ngIf="hoveredMarker.tooltipData.productQualifications?.length">
              <span
                class="mtt-qual-tag"
                *ngFor="let q of hoveredMarker.tooltipData.productQualifications"
                >{{ q }}</span
              >
            </div>
          </div>
        </ng-container>

        <!-- Tractor -->
        <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'tractor'">
          <div class="mtt-header mtt-tractor">
            <i class="fa fa-truck"></i> Tractor {{ hoveredMarker.tooltipData.tractorNumber }}
          </div>
          <div class="mtt-body">
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.assignedDriverName">
              <span class="mtt-label"><i class="fa fa-user"></i> Driver</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.assignedDriverName }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
              <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
              <span class="mtt-value">
                {{ hoveredMarker.tooltipData.location }}
                <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
                  >({{ hoveredMarker.tooltipData.locationAge }})</span
                >
              </span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.attachedTrailerNumbers?.length">
              <span class="mtt-label"><i class="fa fa-list"></i> Trailers</span>
              <span class="mtt-value">{{
                hoveredMarker.tooltipData.attachedTrailerNumbers!.join(", ")
              }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.terminal">
              <span class="mtt-label"><i class="fa fa-building"></i> Terminal</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.terminal }}</span>
            </div>
            <div
              class="mtt-badge"
              [class.mtt-badge-success]="hoveredMarker.tooltipData.inService"
              [class.mtt-badge-danger]="!hoveredMarker.tooltipData.inService"
            >
              {{ hoveredMarker.tooltipData.inService ? "In Service" : "Out of Service" }}
            </div>
          </div>
        </ng-container>

        <!-- Trailer -->
        <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'trailer'">
          <div class="mtt-header mtt-trailer">
            <i class="fa fa-list"></i> Trailer {{ hoveredMarker.tooltipData.trailerNumber }}
            <span class="mtt-equip-code" *ngIf="hoveredMarker.tooltipData.equipmentCode">{{
              hoveredMarker.tooltipData.equipmentCode
            }}</span>
          </div>
          <div class="mtt-body">
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.assignedDriverName">
              <span class="mtt-label"><i class="fa fa-user"></i> Driver</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.assignedDriverName }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
              <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
              <span class="mtt-value">
                {{ hoveredMarker.tooltipData.location }}
                <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
                  >({{ hoveredMarker.tooltipData.locationAge }})</span
                >
              </span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.attachedTractorNumber">
              <span class="mtt-label"><i class="fa fa-truck"></i> On Tractor</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.attachedTractorNumber }}</span>
            </div>
            <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.terminal">
              <span class="mtt-label"><i class="fa fa-building"></i> Terminal</span>
              <span class="mtt-value">{{ hoveredMarker.tooltipData.terminal }}</span>
            </div>
            <div
              class="mtt-badge"
              [class.mtt-badge-success]="hoveredMarker.tooltipData.inService"
              [class.mtt-badge-danger]="!hoveredMarker.tooltipData.inService"
            >
              {{ hoveredMarker.tooltipData.inService ? "In Service" : "Out of Service" }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Assign to Scheduling Team Modal -->
  <app-assign-driver-modal
    [(visible)]="showAssignScheduleModal"
    [driverId]="assignScheduleDriver?.id ?? null"
    [existingTeamId]="assignModalExistingTeamId"
    [existingBoardId]="assignModalExistingBoardId"
    [existingBillToId]="assignModalExistingBillToId"
    (assignSuccess)="onAssignOrUpdateSuccess($event)"
    (updateSuccess)="onUpdateSuccess()"
    (unassignSuccess)="onUnassignSuccess()"
  ></app-assign-driver-modal>
</div>
